import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  getDashboardById,
  getDashboardList,
} from '../../services/DashboardService'

interface GetDashboardListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface DashboardState {
    DashboardList: any
    dashboard: any
}

const initialState: DashboardState = {
    DashboardList: null,
    dashboard: null,
}

// Fetch Dashboard list
export const getOfferListApi = createAsyncThunk(
  'dashboard/getDashboardList',
  async ({pageNumber, pageSize, filterkey}: GetDashboardListParams, {rejectWithValue}) => {
    try {
      const result = await getDashboardList()
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch Dashboard by ID
export const getDashboardByIdApi = createAsyncThunk(
  'dashboard/getOfferById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getDashboardById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)



const DashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getOfferListApi.fulfilled, (state, action) => {
        state.DashboardList = action.payload
      })
      .addCase(getDashboardByIdApi.fulfilled, (state, action) => {
        state.dashboard = action.payload
      })
  },
})

export default DashboardSlice
